/*!
 * vue-grid v0.10.17 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { generator, prepareProps, prepareResolver } from '@aspectus/vue-bem-styled-tag';
import { mapSame, StylingPropsMixin } from '@aspectus/vue-bem-styling';
import { Tag } from '@aspectus/vue-tag';
import { createBlockGenerator } from '@aspectus/bem';
import { makeF, mergeContext } from '@aspectus/vue-utils';
import { flatten } from 'ramda';

var BEM_CONFIG = {
  n: 'g-'
};
var b = createBlockGenerator(BEM_CONFIG);

var block = b('row');
var Row = Object.assign(generator({
  tag: Tag,
  block: block,
  modifiers: mapSame('justify', 'content', 'space')
}), {
  name: 'row'
});

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var block$1 = b('cols');
var normalizerRegex = /\s/img;
function normalizePassedTypes(elements) {
  return flatten(flatten(elements).filter(function (x) {
    return !!x;
  }).map(function (x) {
    return x.split(normalizerRegex);
  }));
}
function cols() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  return block$1(normalizePassedTypes(types).reduce(function (acc, type) {
    acc[type] = true;
    return acc;
  }, {}));
}

var block$2 = b('cell');
var options = {
  modifiers: {
    justify: 'justify'
  }
};
var resolver = prepareResolver(options);
var Cell = makeF(function (h, context) {
  var c = context.props.cols;

  var _resolver = resolver(context.props),
      _resolver2 = _slicedToArray(_resolver, 1),
      modifiers = _resolver2[0];

  return h(Tag, mergeContext(context.data, {
    class: [block$2(modifiers), c && cols(c) || null]
  }), context.children);
}, Object.assign(prepareProps(options), {
  cols: {}
}), 'cell', {
  mixins: [StylingPropsMixin]
});

var block$3 = b('container');
var Container = Object.assign(generator({
  tag: Tag,
  block: block$3,
  modifiers: {
    space: 'space'
  }
}), {
  name: 'container'
});

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$containerName = _ref.containerName,
      containerName = _ref$containerName === void 0 ? Container.name : _ref$containerName,
      _ref$rowName = _ref.rowName,
      rowName = _ref$rowName === void 0 ? Row.name : _ref$rowName,
      _ref$cellName = _ref.cellName,
      cellName = _ref$cellName === void 0 ? Cell.name : _ref$cellName;

  Vue.component(containerName, Container);
  Vue.component(rowName, Row);
  Vue.component(cellName, Cell);
}
var main = {
  Cell: Cell,
  Row: Row,
  Container: Container,
  cols: cols,
  b: b,
  install: install
};

export default main;
export { Cell, Container, Row, b, cols, install };
